import React from 'react';
import { Feltgruppe } from 'src/api/v2';
import { Divider, Heading } from '@innovationnorway/cl-react';
import OwiFormField from './OwiFormField';
import { slugify } from '../../../utils/slugify';

const OwiFormFieldGroup = ({ fieldGroup, lastItem }: { fieldGroup: Feltgruppe; lastItem?: boolean }) => {
  const anchorId = slugify(fieldGroup.navn);
  const fields = fieldGroup.felter?.filter((field) => field.verdi || field.felter?.length) ?? [];
  return (
    <div id={anchorId} className="owi-form--field-group">
      <Heading className="font-size--ds-6" level={3}>
        {fieldGroup.navn}
      </Heading>
      <div className="display--flex flex-direction--column gap--ds-8 margin-top--ds-6">
        {fields.map((field) => (
          <OwiFormField key={field.navn} field={field} />
        ))}
      </div>
      {!lastItem && <Divider className="margin-top--ds-12 margin-bottom--0" />}
    </div>
  );
};

export default OwiFormFieldGroup;
